import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Pagination } from '../../../../../../common/pagination'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { SelectCustom } from '../../../../../../common/selectCustom'
import { Table } from '../../../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { Z_INDEX } from '../../../../../../utils/common'
import { recommendSchema } from '../../../constants'
import {
  changeActiveSavedPortfolio,
  changePortfolioPage,
  selectActiveSavedPortfolio,
  selectIsLoadingPortfolio,
  selectPortfolioData,
  selectPortfolioDataItem,
  selectPortfolioIds,
  selectPortfolioPage,
  selectPortfolioTotalRecords,
  selectSavedPortfolioList,
  selectSelectedCompanyList,
} from '../store/slice'
import { getRecommendationPortfolio, getSavedPortfolio } from '../store/thunk'
import { CustomScoreCell } from './common/CustomScoreCell'
import { FirstColumnCell } from './common/FirstColumnCell'

export const Portfolio = () => {
  const dispatch = useDispatch()
  const { formatCurrency } = useFormatCurrency(SCREEN.PEER_ANALYSIS)

  const savedPortfolioList = useSelector(selectSavedPortfolioList)
  const activeSavedPortfolio = useSelector(selectActiveSavedPortfolio)
  const selectedCompanyList = useSelector(selectSelectedCompanyList)
  const ids = useSelector(selectPortfolioIds)
  const totalRecords = useSelector(selectPortfolioTotalRecords)
  const page = useSelector(selectPortfolioPage)
  const portfolioData = useSelector(selectPortfolioData)
  const isLoading = useSelector(selectIsLoadingPortfolio)

  useEffect(() => {
    dispatch(
      getSavedPortfolio({
        Sort: 'CreateDate',
        SortDirection: 'Descending',
        PageSize: 300,
      }),
    )
  }, [])

  useEffect(() => {
    if (activeSavedPortfolio) {
      dispatch(
        getRecommendationPortfolio({
          PortfolioId: activeSavedPortfolio.value,
          Page: 1,
          PageSize: 10,
        }),
      )
      setPage(1)
    }
  }, [activeSavedPortfolio])

  useEffect(() => {
    if (activeSavedPortfolio) {
      dispatch(
        getRecommendationPortfolio({
          PortfolioId: activeSavedPortfolio.value,
          Page: page,
          PageSize: 10,
        }),
      )
    }
  }, [page])

  const onChangePortfolio = (e) => {
    if (e.value === activeSavedPortfolio.value) return
    dispatch(changeActiveSavedPortfolio(e))
  }

  const setPage = (value) => {
    dispatch(changePortfolioPage(value))
  }

  return (
    <div className="flexColumn">
      <div className="dFlex alignItemsCenter my1">
        <Translate
          className="fw600"
          value="companyAnalysis.peerAnalysis.CHOOSE_PORTFOLIO"
        />
        <SelectCustom
          activeItem={activeSavedPortfolio}
          isI18n={false}
          data={savedPortfolioList}
          chooseItem={onChangePortfolio}
          isBorderNone
          zIndex={Z_INDEX.MODAL + 1}
          customWidthDropdown={400}
          style={{ maxWidth: 400 }}
        />
      </div>

      <Table
        ids={ids}
        getDataFromRedux={selectPortfolioDataItem}
        isLoading={isLoading}
        isNoDataWithHead={true}
        autoHeightMax={450}
        schema={recommendSchema.map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              render: (val) => (
                <FirstColumnCell
                  val={val}
                  selectedCompanyList={selectedCompanyList}
                  data={portfolioData}
                  typeSelect={'selectOne'}
                />
              ),
              renderTh: (val) => (
                <FirstColumnCell
                  val={val}
                  selectedCompanyList={selectedCompanyList}
                  data={portfolioData}
                  typeSelect={'selectAll'}
                />
              ),
            }
          }

          if ([1, 2].includes(index)) {
            return {
              ...item,
              render: (val) => (
                <TextEllipsisStaticLine
                  zIndexTooltip={15}
                  text={val}
                  isI18n={false}
                  lineClamp={2}
                />
              ),
            }
          }

          if ([4, 3].includes(index)) {
            return {
              ...item,
              render: (value) => formatCurrency({ value }),
            }
          }

          if ([6, 7].includes(index)) {
            return {
              ...item,
              render: (val) => (
                <CustomScoreCell
                  val={val}
                  typeCell={index === 6 ? 'CREDIT_RISK' : 'PERFORMANCE'}
                />
              ),
            }
          }

          return item
        })}
        renderPagination={() => (
          <Pagination
            page={page}
            pageSize={10}
            total={totalRecords}
            setPage={setPage}
            className="pt2"
            isShowPageSize={false}
          />
        )}
      />
    </div>
  )
}
